import { ProtectionAdditionalQuoteModalData } from '../../models/protection-details/protection-additional-quote-modal-data.interface';
import { mockRegistrationApplianceDetails } from '../registration-appliance-details/registration-appliance-details.mock';
import { mockProtectionAdditionalQuotes } from './protection-additional-quotes.mock';

export const mockProtectionAdditionalQuoteModalData: ProtectionAdditionalQuoteModalData =
  {
    additionalQuotes: mockProtectionAdditionalQuotes,
    applianceDetails: mockRegistrationApplianceDetails,
  };
